import Buttons from "views/Components/Buttons.jsx";
import GridSystem from "views/Components/GridSystem.jsx";
import Panels from "views/Components/Panels.jsx";
import SweetAlert from "views/Components/SweetAlert.jsx";
import Notifications from "views/Components/Notifications.jsx";
import Icons from "views/Components/Icons.jsx";
import Typography from "views/Components/Typography.jsx";
import RegularForms from "views/Forms/RegularForms.jsx";
import ExtendedForms from "views/Forms/ExtendedForms.jsx";
import ValidationForms from "views/Forms/ValidationForms.jsx";
import Wizard from "views/Forms/Wizard.jsx";
import RegularTables from "views/Tables/RegularTables.jsx";
import ExtendedTables from "views/Tables/ExtendedTables.jsx";
import ReactTables from "views/Tables/ReactTables.jsx";
import GoogleMaps from "views/Maps/GoogleMaps.jsx";
import FullScreenMap from "views/Maps/FullScreenMap.jsx";
import VectorMap from "views/Maps/VectorMap.jsx";
import Charts from "views/Charts/Charts.jsx";
import Calendar from "views/Calendar/Calendar.jsx";
import Widgets from "views/Widgets/Widgets.jsx";
import TimelinePage from "views/Pages/Timeline.jsx";
import RTLSupport from "views/Pages/RTLSupport.jsx";


// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import ContentPaste from "@material-ui/icons/ContentPaste";
import GridOn from "@material-ui/icons/GridOn";
import Place from "@material-ui/icons/Place";
import WidgetsIcon from "@material-ui/icons/Widgets";
import Timeline from "@material-ui/icons/Timeline";
import DateRange from "@material-ui/icons/DateRange";



var devRoutes = [
  {
    roles: ["dev"],
    collapse: true,
    path: "/dev/components",
    name: "Components",
    state: "openComponents",
    icon: Apps,
    views: [
        {
          path: "/dev/timeline-page",
          name: "Timeline Page",
          mini: "TP",
          component: TimelinePage
        },
        {
          path: "/dev/rtl/rtl-support-page",
          name: "RTL Support",
          mini: "RS",
          component: RTLSupport
        },
        {
        path: "/dev/components/buttons",
        name: "Buttons",
        mini: "B",
        component: Buttons
      },
      {
        path: "/dev/components/grid-system",
        name: "Grid System",
        mini: "GS",
        component: GridSystem
      },
      {
        path: "/dev/components/panels",
        name: "Panels",
        mini: "P",
        component: Panels
      },
      {
        path: "/dev/components/sweet-alert",
        name: "Sweet Alert",
        mini: "SA",
        component: SweetAlert
      },
      {
        path: "/dev/components/notifications",
        name: "Notifications",
        mini: "N",
        component: Notifications
      },
      { path: "/dev/components/icons", name: "Icons", mini: "I", component: Icons },
      {
        path: "/dev/components/typography",
        name: "Typography",
        mini: "T",
        component: Typography
      }
    ]
  },
  {
    roles: ["dev"],    
    collapse: true,
    path: "/dev/forms",
    name: "Forms",
    state: "openForms",
    icon: ContentPaste,
    views: [
      {
        path: "/dev/forms/regular-forms",
        name: "Regular Forms",
        mini: "RF",
        component: RegularForms
      },
      {
        path: "/dev/forms/extended-forms",
        name: "Extended Forms",
        mini: "EF",
        component: ExtendedForms
      },
      {
        path: "/dev/forms/validation-forms",
        name: "Validation Forms",
        mini: "VF",
        component: ValidationForms
      },
      { path: "/dev/forms/wizard", name: "Wizard", mini: "W", component: Wizard }
    ]
  },
  {
    roles: ["dev"],    
    collapse: true,
    path: "/dev/tables",
    name: "Tables",
    state: "openTables",
    icon: GridOn,
    views: [
      {
        path: "/dev/tables/regular-tables",
        name: "Regular Tables",
        mini: "RT",
        component: RegularTables
      },
      {
        path: "/dev/tables/extended-tables",
        name: "Extended Tables",
        mini: "ET",
        component: ExtendedTables
      },
      {
        path: "/dev/tables/react-tables",
        name: "React Tables",
        mini: "RT",
        component: ReactTables
      }
    ]
  },
  {
    roles: ["dev"],    
    collapse: true,
    path: "/dev/maps",
    name: "Maps",
    state: "openMaps",
    icon: Place,
    views: [
      {
        path: "/dev/maps/google-maps",
        name: "Google Maps",
        mini: "GM",
        component: GoogleMaps
      },
      {
        path: "/dev/maps/full-screen-maps",
        name: "Full Screen Map",
        mini: "FSM",
        component: FullScreenMap
      },
      {
        path: "/dev/maps/vector-maps",
        name: "Vector Map",
        mini: "VM",
        component: VectorMap
      }
    ]
  },
  { roles: ["dev"], path: "/dev/widgets", name: "Widgets", icon: WidgetsIcon, component: Widgets },
  { roles: ["dev"], path: "/dev/charts", name: "Charts", icon: Timeline, component: Charts },
  { roles: ["dev"], path: "/dev/calendar", name: "Calendar", icon: DateRange, component: Calendar },
  ];

  export default devRoutes;



// WEBPACK FOOTER //
// ./src/routes/dev.jsx